<template>
  <v-toolbar class="escalon-dialog-header primary" height="35">
    <img
      class="modal-axis-logo mr-2"
      :src="require('../../assets/' + coloredLogo)" />
    <span>Administration Center</span>
    <v-spacer/>
    <router-link to="/patients" class="close">
      <v-btn text>
        <v-avatar size="20" class="mr-2">
          <img :src="require('../../assets/' + coloredAssetUrls.close)">
        </v-avatar>Close
      </v-btn>
    </router-link>
  </v-toolbar>
</template>

<script>

export default {
  name: "AdminPanelHeader"
}
</script>

<style lang="scss" scoped>
.close {
  text-decoration: none;
  .close-logo {
    width: 20px;
    margin-right: 5px;
    display: inline;
    vertical-align: middle;
  }

  .close-text {
    font-size: 15px !important;
    display: inline;
    color: white;
    vertical-align: middle;
  }
}

</style>